import { render, staticRenderFns } from "./MultiInput.vue?vue&type=template&id=8b6b5e66&scoped=true&"
import script from "./MultiInput.vue?vue&type=script&lang=js&"
export * from "./MultiInput.vue?vue&type=script&lang=js&"
import style0 from "./MultiInput.vue?vue&type=style&index=0&id=8b6b5e66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6b5e66",
  null
  
)

export default component.exports